import { render } from "./Tabs.vue?vue&type=template&id=672c60d0&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=672c60d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672c60d0"]])

export default __exports__